import React from 'react';

import { FaDev, FaGithub } from 'react-icons/fa6';
import { TbApi } from 'react-icons/tb';

import { HeaderMenuDrawerCollapsible, HeaderMenuDrawerSingle } from '../HeaderMenuDrawerComponents';

const HeaderMenuDrawerSettings: React.FC = () => {
  return (
    <HeaderMenuDrawerCollapsible Icon={FaDev} label="Developers">
      <HeaderMenuDrawerSingle href={'https://github.com/pactswapdex'} Icon={FaGithub}>
        Github
      </HeaderMenuDrawerSingle>
      <HeaderMenuDrawerSingle href={'https://docs.pactswap.io/api'} Icon={TbApi}>
        API Docs
      </HeaderMenuDrawerSingle>
    </HeaderMenuDrawerCollapsible>
  );
};

export default HeaderMenuDrawerSettings;
